import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, useLang } from "@/i18n/LanguageContext";
import LanguageGate from "@/components/LanguageGate";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import WhyUs from "@/pages/WhyUs";
import Contact from "@/pages/Contact";
import Hipaa from "@/pages/Hipaa";

function Shell() {
  const { chosen } = useLang();

  if (!chosen) {
    return <LanguageGate />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/why-medprime" element={<WhyUs />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/hipaa" element={<Hipaa />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <Shell />
        <Toaster position="top-right" theme="dark" />
      </LanguageProvider>
    </div>
  );
}

export default App;
